var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.4599 39.4935V68.3542H17.5401V5.69618H22.4599V34.5806H40V7.16769C40 3.2041 36.7914 0 32.8223 0H0V74.0741H32.8223C36.7914 74.0741 40 70.87 40 66.9064V39.4935H22.4599Z","fill":"#FBF4EF"}));
}

Logo.defaultProps = {"width":"40","height":"75","viewBox":"0 0 40 75","fill":"none"};

module.exports = Logo;

Logo.default = Logo;
